/* casam-cart.js — native cart drawer add-ons (UpCart retirement P1). External asset (no inline-HTML, per geoblock P0 lesson).
   2026-06-08: add-source attribution — every JS-driven /cart/add.js now stamps a hidden line-item property
   properties._added_from ('cart_upsell' | 'search'). Hidden (underscore) = invisible to customer, persists to the order. */
(function(){
  var CFG=window.CASAM_CART||{};
  var THRESHOLD=CFG.freeShipThreshold||7500;
  var ENDPOINT=CFG.endpoint||'/apps/reviews/cart-upsell';
  var busy=false,lastKey=null,upsellLoaded=false,upsellInflight=false,t=null;

  /* ── BYO default contents (DRM-802, owner ruling 2026-08-23) ──────────────
     Only the BYO builder emits _byo_skus. Every OTHER way to add the BYO
     3-Pack — collection-card Quick Add, the AI cart drawer upsell, omni
     search, HP quick view, a promo add — posts just the variant id, which put
     a $49.99 pack in the cart with NOTHING in it: cart-byo-contents.liquid
     rendered no contents row, and the ShipStation packing slip handed the
     floor a pack with no shakers to put in it. An unconfigured BYO add now
     defaults to the Everyday Kitchen Pack trio (server-resolved into
     CASAM_CART.byoDefault by cart-drawer.liquid).

     This sits on fetch rather than in addWithSource because addWithSource is
     only ONE of the add paths — omni-search, HP quick view and casam-promos
     each own their own /cart/add.js call, and patching five call sites is how
     this bug comes back the next time a sixth surface is added. One guard at
     the transport covers every present and future caller.

     It is deliberately hard for this to do anything except add missing
     properties:
       * only /cart/add requests are inspected, and only JSON bodies;
       * only a line whose id matches the BYO variant is touched;
       * a line that already carries _byo_skus is left alone, so a pack the
         shopper actually configured can never be overwritten;
       * ANY throw anywhere falls through to the original request untouched —
         a broken guard must never break the cart.
     Non-JSON bodies (FormData/urlencoded product forms) pass through: the BYO
     PDP is the builder itself, so no Impulse form can post this variant. */
  function byoFill(props){
    var BYO=CFG.byoDefault;
    if(!BYO||!BYO.vid)return false;
    if(!props||props._byo_skus)return false;
    props['Your blends']=BYO.blends;
    props._byo_skus=BYO.skus;
    props._byo_handles=BYO.handles;
    props._byo_titles=BYO.titles;
    props._byo_default=BYO.pack||'EKP3PSSS';
    return true;
  }
  function byoPatchLine(line){
    var BYO=CFG.byoDefault;
    if(!BYO||!BYO.vid||!line||String(line.id)!==String(BYO.vid))return false;
    if(!line.properties)line.properties={};
    return byoFill(line.properties);
  }
  (function(){
    var BYO=CFG.byoDefault;
    if(!BYO||!BYO.vid||typeof window.fetch!=='function')return;
    var orig=window.fetch;
    window.fetch=function(input,init){
      try{
        var url=(typeof input==='string')?input:(input&&input.url)||'';
        /* Anchor to THIS origin and the exact path. A bare substring test also
           matched a third-party URL that merely contained "/cart/add" in a
           query string. Nothing sensitive was ever added — the payload is five
           store-public SKUs already in page source — but a body rewrite should
           never fire on a request that isn't ours. Malformed URLs throw and
           fall through to the untouched request via the enclosing catch. */
        var u=new URL(url,location.href);
        if(u.origin===location.origin&&/^\/cart\/add(\.js)?$/.test(u.pathname)&&init&&typeof init.body==='string'){
          var b=JSON.parse(init.body),touched=false;
          if(b&&Array.isArray(b.items)){
            for(var i=0;i<b.items.length;i++){if(byoPatchLine(b.items[i]))touched=true;}
          }else if(b&&b.id!=null){
            touched=byoPatchLine(b);
          }
          if(touched){
            var next={};for(var k in init){next[k]=init[k];}
            next.body=JSON.stringify(b);
            return orig.call(this,input,next);
          }
        }
      }catch(e){/* never break the cart over a default */}
      return orig.apply(this,arguments);
    };
  })();
  /* DRM-437: the upsell endpoint is LLM-backed (seconds of latency + real spend per
     call). Never call it on a plain page load — arm only once the shopper actually
     engages the cart (drawer open / add-to-cart), or on the /cart page itself.
     Segment match (not a bare prefix) so a handle like /cartography can't re-arm
     the LLM call on a plain page load — the exact regression this guards against. */
  var upsellArmed=/^\/cart(\/|$)/.test(location.pathname);
  var UPSELL_COUNT=CFG.upsellCount||5;
  /* DRM-470: an armed refresh can read /cart.js BEFORE a just-clicked add is
     reflected (stale in-flight snapshot or cart-state lag), producing a transient
     {"items":[]} LLM POST during an add-to-cart — pure spend waste (DRM-437
     residual). We stamp every add signal (form submit, ajaxProduct:added, our own
     quick-adds) and suppress the EMPTY-cart POST inside that settle window; the
     populated refresh that follows via the [data-products] observer fires normally.
     A genuinely empty drawer open (no recent add) still fetches "Start your order". */
  var lastAddAt=0,ADD_SETTLE_MS=4000;
  function markAdd(){lastAddAt=Date.now();}
  function money(c){return '$'+(Math.round(c)/100).toFixed(2);}
  function dollars(p){return p?('$'+parseFloat(p).toFixed(2)):'';}
  /* also escape quotes — esc() output lands inside double-quoted attributes (cardHtml) */
  function esc(s){var d=document.createElement('div');d.textContent=(s==null?'':String(s));return d.innerHTML.replace(/"/g,'&quot;').replace(/'/g,'&#39;');}
  /* hrefs need a scheme gate too — esc() can't stop javascript: URIs */
  function safeUrl(s){s=(s==null?'':String(s));return (/^(https?:)?\/\//i.test(s)||s.charAt(0)==='/')?s:'#';}
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});}
  /* DRM-231: product handle from an upsell URL ('/products/<handle>?...') for _casam_upsell_pick */
  function pickHandle(url){var m=/\/products\/([^/?#]+)/.exec(url||'');return m?m[1]:'';}

  /* DRM-305: subscribe-eligibility resolved from the PUBLIC /products/<handle>.js
     (selling_plan_groups + per-variant selling_plan_allocations) — the same data
     the native PDP picker uses, so no Admin scope/token needed. Cached per handle. */
  var _prodJsonCache={};
  function productJson(handle){
    if(_prodJsonCache[handle])return _prodJsonCache[handle];
    var p=fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    _prodJsonCache[handle]=p;return p;
  }
  /* Pick the monthly Club Casa plan for this variant, or null if not eligible. */
  function monthlyPlanFor(prod,vid){
    var groups=(prod&&prod.selling_plan_groups)||[],g=null,i;
    for(i=0;i<groups.length;i++){if(/club casa/i.test(groups[i].name||'')){g=groups[i];break;}}
    if(!g)g=groups[0];
    if(!g||!g.selling_plans||!g.selling_plans.length)return null;
    var plans=g.selling_plans,plan=null,nm;
    for(i=0;i<plans.length;i++){nm=(plans[i].name||'').toLowerCase();
      if(nm.indexOf('month')>-1&&nm.indexOf('2 month')<0&&nm.indexOf('3 month')<0){plan=plans[i];break;}}
    if(!plan)plan=plans[0];
    /* confirm this exact variant is allocated to the plan (eligibility) */
    var vars=prod.variants||[],v=null;
    for(i=0;i<vars.length;i++){if(String(vars[i].id)===String(vid)){v=vars[i];break;}}
    if(v&&v.selling_plan_allocations&&v.selling_plan_allocations.length){
      for(i=0;i<v.selling_plan_allocations.length;i++){
        if(String(v.selling_plan_allocations[i].selling_plan_id)===String(plan.id))return plan;}
      return null;
    }
    return plan;
  }
  /* After cards paint, lazily add a "Subscribe & save 10%" action to eligible ones. */
  function enrichSubscribe(node){
    if(!node)return;
    var cells=node.querySelectorAll('.casam-upsell__cell');
    Array.prototype.forEach.call(cells,function(cell){
      var add=cell.querySelector('.casam-upsell__add');
      if(!add||cell.querySelector('.casam-upsell__sub'))return;
      var handle=add.getAttribute('data-handle'),vid=add.getAttribute('data-vid');
      if(!handle||!vid)return;
      productJson(handle).then(function(prod){
        if(!prod)return;var plan=monthlyPlanFor(prod,vid);if(!plan)return;
        if(cell.querySelector('.casam-upsell__sub'))return;
        var b=document.createElement('button');
        b.type='button';b.className='casam-upsell__sub';
        b.setAttribute('data-vid',vid);b.setAttribute('data-handle',handle);
        b.setAttribute('data-plan',plan.id);
        if(add.getAttribute('data-source'))b.setAttribute('data-source',add.getAttribute('data-source'));
        b.textContent='Subscribe & save 10%';
        (add.closest('.casam-upsell__buy')||add.parentNode).appendChild(b);
      });
    });
  }

  /* DRM-306: per-line "make it a subscription" nudge on eligible ONE-TIME drawer
     lines. Drives off /cart.js (handle, variant_id, key, existing selling plan) and
     matches DOM lines by .cart__item[data-key]; converts in place via /cart/change.js
     selling_plan (verified to preserve line properties). Idempotent — safe to re-run
     on every refresh / theme rebuild. */
  function renderLineNudges(cart){
    var host=document.querySelector('[data-products]');
    if(!host||!cart||!cart.items)return;
    cart.items.forEach(function(item){
      if(!item||item.selling_plan_allocation||!item.handle)return;   // skip existing subscriptions
      /* DRM-796: skip BYO bundle lines — a pack parent or a zeroed pack child
         must never grow a per-line "make it a subscription" nudge. */
      var bp=item.properties||{};
      if(bp._bundle||bp._bundle_parent)return;
      var line=host.querySelector('.cart__item[data-key="'+item.key+'"]');
      if(!line||line.querySelector('.casam-line-sub'))return;
      productJson(item.handle).then(function(prod){
        if(!prod)return;var plan=monthlyPlanFor(prod,item.variant_id);if(!plan)return;
        var l=host.querySelector('.cart__item[data-key="'+item.key+'"]');  // re-find (DOM may rebuild)
        if(!l||l.querySelector('.casam-line-sub'))return;
        var b=document.createElement('button');
        b.type='button';b.className='casam-line-sub';
        b.setAttribute('data-key',item.key);b.setAttribute('data-plan',plan.id);
        b.innerHTML='↻ Make it a subscription · <strong>save 10%</strong>';
        l.appendChild(b);
      });
    });
  }
  /* Convert an existing one-time line to the monthly Club Casa plan in place. */
  function convertLineToSub(key,plan,btn){
    if(busy)return;busy=true;
    var orig=btn?btn.innerHTML:'';if(btn){btn.disabled=true;btn.textContent='Updating…';}
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,selling_plan:Number(plan)||plan})})
      .then(function(){lastKey=null;upsellLoaded=false;document.dispatchEvent(new CustomEvent('cart:build'));
        return new Promise(function(res){setTimeout(res,400);});})
      .then(function(){refresh();}).catch(function(){})
      .then(function(){busy=false;if(btn){btn.disabled=false;btn.innerHTML=orig;}});
  }

  function renderFreeShip(cart){
    var n=document.querySelector('[data-casam-freeship]');if(!n)return;
    var total=cart.total_price||0,rem=THRESHOLD-total,pct=Math.max(0,Math.min(100,(total/THRESHOLD)*100));
    var unlocked=rem<=0;
    var msg=unlocked?'<strong>Free shipping unlocked!</strong> (lower 48)':("You're <strong>"+money(rem)+"</strong> away from free shipping (lower 48)");
    n.className='casam-fs'+(unlocked?' is-unlocked':'');
    n.innerHTML='<div class="casam-fs__msg">'+(unlocked?'✓ ':'')+msg+'</div><div class="casam-fs__track"><div class="casam-fs__fill" style="width:'+pct+'%"></div></div>';
    n.hidden=false;
  }

  function starsHtml(rating){
    if(!rating)return '';
    var full=Math.round(rating),s='';
    for(var i=1;i<=5;i++){s+='<span class="casam-star'+(i<=full?' is-on':'')+'">★</span>';}
    return s;
  }

  /* One recommendation card (carousel cell). Quick-add binds via the existing
     '.casam-upsell__add' click handler (data-vid + data-handle) — works for every cell. */
  function cardHtml(u){
    if(!u)return '';
    var img=u.image?(u.image+(u.image.indexOf('?')>-1?'&width=240':'?width=240')):'';
    var vars=(u.variants&&u.variants.length)?u.variants:[{id:u.variant_id,title:'',price:u.price}];
    var rating=u.rating,rc=parseInt(u.review_count,10)||0;
    var ratingHtml=rating?('<div class="casam-upsell__rating">'+starsHtml(rating)+'<span class="casam-upsell__rcount">'+rating.toFixed(1)+(rc?' ('+rc+')':'')+'</span></div>'):'';
    /* External-buy linkout branch — DORMANT since DRM-448 (ratified 2026-07-06):
       VEG/KST upsell cards are normal add-to-cart (they're buyable from us via
       search / quick-add / the AI upsell; only the PDP add is suppressed), and the
       upsell service no longer emits external_buy_url. The branch is kept as a
       generic capability: if a future card ever carries external_buy_url it renders
       a "Buy on …" link opening in a new tab instead of Add, mirroring the PDP CTA
       swap. No .casam-upsell__add button ⇒ quick-add + subscribe enrich skip it. */
    var ext=u.external_buy_url?safeUrl(u.external_buy_url):'';
    var linkUrl=ext||safeUrl(u.url);
    var linkTarget=ext?' target="_blank" rel="noopener noreferrer"':'';
    var buyRow=ext
      ? '<div class="casam-upsell__buy casam-upsell__buy--external"><a class="casam-upsell__extbuy btn--full" href="'+esc(ext)+'" target="_blank" rel="noopener noreferrer" data-external-buy'+(u.external_buy_channel?(' data-channel="'+esc(u.external_buy_channel)+'"'):'')+'>'+esc(u.external_buy_label||'Buy on Amazon')+' ↗</a></div>'
      : '<div class="casam-upsell__buy"><span class="casam-upsell__price">'+dollars(vars[0].price||u.price)+'</span><button type="button" class="casam-upsell__add" data-vid="'+esc(vars[0].id)+'" data-handle="'+esc(pickHandle(u.url))+'"'+(u.picked_by==='restock'?' data-source="restock"':'')+'>Add</button></div>';
    return ''+
      '<div class="casam-upsell__cell">'+
        '<a class="casam-upsell__imgwrap" href="'+esc(linkUrl)+'"'+linkTarget+'><img class="casam-upsell__img" src="'+esc(img)+'" alt="'+esc(u.title)+'" loading="lazy"></a>'+
        '<a class="casam-upsell__name" href="'+esc(linkUrl)+'"'+linkTarget+'>'+esc(u.title)+'</a>'+
        ratingHtml+
        (u.reason?'<div class="casam-upsell__reason">'+esc(u.reason)+'</div>':'')+
        buyRow+
      '</div>';
  }

  /* The empty-cart drawer (.drawer__cart-empty) is always in the DOM — the theme just
     CSS-hides it unless .is-empty. We inject our own recs host into it so an empty cart
     opens to a carousel instead of a dead end. */
  function emptyHost(){
    var box=document.querySelector('#CartDrawer .drawer__cart-empty');
    if(!box)return null;
    var h=box.querySelector('[data-casam-empty-recs]');
    if(!h){h=document.createElement('div');h.setAttribute('data-casam-empty-recs','');h.className='casam-upsell casam-upsell--empty';box.appendChild(h);}
    return h;
  }
  function paintCarousel(node,title,cards){
    if(!node)return;
    if(!cards){node.hidden=true;node.innerHTML='';return;}
    node.innerHTML='<div class="casam-upsell__title">'+esc(title)+'</div><div class="casam-upsell__row">'+cards+'</div>';
    node.hidden=false;
  }

  /* DRM-796: SKUs sitting inside a BYO pack (lines carrying properties._bundle)
     must not be re-suggested by the upsell. The list is server-provided (LLM),
     so we filter the RENDERED suggestions by variant id, product id and handle.

     Handles are compared DECODED and lowercased (re-landed from 9f39353 after
     the a94913b revert): pickHandle() pulls the raw path segment out of a
     suggestion URL, so Texas Twister arrives as
     `casa-m-spice-co%C2%AE-texas-twister%E2%84%A2` while the cart item carries
     the decoded Liquid handle `casa-m-spice-co®-texas-twister™`. Comparing
     them raw misses, and the blend gets re-suggested while it is sitting in
     the pack. */
  function normHandle(h){
    h=String(h||'').trim();
    if(!h)return '';
    try{h=decodeURIComponent(h);}catch(e){/* malformed %-sequence: use as-is */}
    return h.toLowerCase();
  }
  function bundleChildFilter(cart){
    var ids={},handles={};
    (cart.items||[]).forEach(function(i){
      var p=(i&&i.properties)||{};
      if(p._bundle&&!p._bundle_parent){
        ids[String(i.variant_id)]=1;ids[String(i.product_id)]=1;
        var h=normHandle(i.handle);
        if(h)handles[h]=1;
      }
      /* One-line pack: components are properties, not lines, so the server's
         in-cart exclusion can't see them (and its cache is keyed by product ids,
         so two differently-built packs share one pick — each cart must filter
         its own contents here). _byo_handles rides on every pack line: the
         builder emits it and the Quick-Add default guard writes it. */
      if(p._byo_skus&&typeof p._byo_handles==='string'){
        p._byo_handles.split('|').forEach(function(bh){
          bh=normHandle(bh);
          if(bh)handles[bh]=1;
        });
      }
    });
    return function(u){
      if(!u)return false;
      if(u.product_id&&ids[String(u.product_id)])return false;
      if(u.variant_id&&ids[String(u.variant_id)])return false;
      var vs=u.variants||[];
      for(var i=0;i<vs.length;i++){if(vs[i]&&ids[String(vs[i].id)])return false;}
      var h=normHandle(pickHandle(u.url));
      if(h&&handles[h])return false;
      return true;
    };
  }

  function renderUpsell(cart){
    if(!upsellArmed)return;
    var nPop=document.querySelector('[data-casam-upsell]');
    var empty=(cart.item_count||0)===0;
    /* DRM-470: empty cart + an add in flight/just landed = transient stale read,
       not a real empty drawer. Skip the LLM POST (don't touch lastKey — the settled
       populated refresh must still pass single-flight and fire normally). */
    if(empty&&(Date.now()-lastAddAt)<ADD_SETTLE_MS)return;
    var items=(cart.items||[]).map(function(i){return {product_id:String(i.product_id),variant_id:String(i.variant_id),title:i.product_title||i.title,qty:i.quantity};});
    /* Pack contents join the signature: swapping one BYO pack for a differently
       built one leaves the product-id set unchanged, and the stale key would
       skip the refresh that re-runs bundleChildFilter against the new contents. */
    var byoSig=(cart.items||[]).map(function(i){return (i.properties&&i.properties._byo_skus)||'';}).filter(Boolean).sort().join(';');
    var key=(empty?'EMPTY':items.map(function(i){return i.product_id;}).sort().join(',')+(byoSig?'|'+byoSig:''));
    /* single-flight: an in-flight request for the same cart signature must not be
       re-fired by a second event (init + cart:build used to double-POST on load) */
    if(key===lastKey&&(upsellLoaded||upsellInflight))return;
    lastKey=key;upsellInflight=true;
    fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items,cart_total:cart.total_price,count:UPSELL_COUNT})})
      .then(function(r){return r.json();})
      .then(function(d){
        upsellInflight=false;
        var list=(d&&d.ok)?((d.upsells&&d.upsells.length)?d.upsells:(d.upsell?[d.upsell]:[])):[];
        list=list.filter(bundleChildFilter(cart));  // DRM-796: never re-upsell a pack component
        var eh=emptyHost();
        if(!list.length){upsellLoaded=false;paintCarousel(nPop,'',null);paintCarousel(eh,'',null);if(nPop)nPop.removeAttribute('data-loaded');return;}
        var cards=list.map(cardHtml).join('');
        paintCarousel(nPop,'You might also like',cards);if(nPop)nPop.setAttribute('data-loaded','1');
        paintCarousel(eh,'Start your order',cards);
        enrichSubscribe(nPop);enrichSubscribe(eh);  // DRM-305 subscribe-and-save action
        upsellLoaded=true;
      }).catch(function(){upsellInflight=false;upsellLoaded=false;if(nPop)nPop.hidden=true;});
  }

  document.addEventListener('change',function(e){
    var sel=e.target.closest&&e.target.closest('.casam-upsell__variant');if(!sel)return;
    var opt=sel.options[sel.selectedIndex];var card=sel.closest('.casam-upsell__card');if(!card)return;
    var pr=card.querySelector('.casam-upsell__price');if(pr)pr.textContent=dollars(opt.getAttribute('data-price'));
    var btn=card.querySelector('.casam-upsell__add');if(btn)btn.setAttribute('data-vid',sel.value);
  });

  function refresh(){getCart().then(function(cart){renderFreeShip(cart);renderUpsell(cart);renderLineNudges(cart);}).catch(function(){});}
  function debounced(){clearTimeout(t);t=setTimeout(refresh,250);}

  // Shared add-to-cart with source attribution (hidden line-item property _added_from).
  // DRM-231: extraProps merges additional hidden properties (_casam_upsell, _casam_upsell_pick).
  // DRM-305: optional sellingPlanId → adds the line as a Club Casa subscription
  // (selling_plan on /cart/add.js). Hidden props (_casam_upsell etc.) ride along
  // unchanged, so subscription upsells get attributed exactly like one-time ones.
  function addWithSource(vid,source,btn,extraProps,sellingPlanId){
    if(busy)return;busy=true;
    markAdd();  // DRM-470: open the add-settle window before the /cart/add.js fetch
    var orig=btn?btn.textContent:'';if(btn){btn.disabled=true;btn.textContent='Adding…';}
    var props={'_added_from':source};
    if(extraProps){for(var k in extraProps){if(extraProps[k])props[k]=extraProps[k];}}
    var body={id:vid,quantity:1,properties:props};
    if(sellingPlanId)body.selling_plan=Number(sellingPlanId)||sellingPlanId;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
      .then(function(){lastKey=null;upsellLoaded=false;document.dispatchEvent(new CustomEvent('cart:build'));return new Promise(function(res){setTimeout(res,300);});})
      .then(function(){refresh();}).catch(function(){}).then(function(){busy=false;if(btn){btn.disabled=false;btn.textContent=orig;}});
  }

  /* DRM-231: _casam_upsell:'drawer' + _casam_upsell_pick:<handle> for webhook tagging/rollup. DRM-1677: a signed-in
     shopper's restock pick (picked_by 'restock', data-source="restock") is 'drawer_restock', so the digest counts it
     apart from the AI pick; the order is still tagged Drawer Upsell. */
  function upsellProps(b){
    return {'_casam_upsell':b.getAttribute('data-source')==='restock'?'drawer_restock':'drawer',
            '_casam_upsell_pick':b.getAttribute('data-handle')||''};
  }

  // Cart upsell ("Stack Your Spice Rack") add  → _added_from:'cart_upsell'
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.casam-upsell__add');if(!b)return;
    e.preventDefault();
    addWithSource(b.getAttribute('data-vid'),'cart_upsell',b,upsellProps(b));
  });

  // DRM-305: "Subscribe & save 10%" on the drawer upsell card → same cart_upsell
  // attribution (_casam_upsell:'drawer') PLUS the monthly Club Casa selling plan.
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.casam-upsell__sub');if(!b)return;
    e.preventDefault();
    addWithSource(b.getAttribute('data-vid'),'cart_upsell',b,upsellProps(b),b.getAttribute('data-plan'));
  });

  // DRM-306: convert an existing drawer line to a monthly Club Casa subscription.
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.casam-line-sub');if(!b)return;
    e.preventDefault();
    convertLineToSub(b.getAttribute('data-key'),b.getAttribute('data-plan'),b);
  });

  // Collection/landing-card Quick add. Honor the data-source the Liquid stamps
  // (e.g. 'home' on the index) instead of hardcoding, so home-page
  // quick-adds aren't misattributed as collection adds (DRM-481 / audit #5).
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-casam-qa]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    addWithSource(b.getAttribute('data-vid'),b.getAttribute('data-source')||'collection_quick_add',b);
  });

  // Recipe-page Quick add (recipes landing SHOP STRIP + recipe-detail "Made with")
  // → _added_from:'recipe'. Button carries data-handle (not a variant id) so multi-variant
  // blends resolve to the hero shaker (same rule as the search quick-add: featured-image
  // variant, else a 10SSS/09CTJ/09CTL SKU, else first available). Opens the drawer on add.
  // DRM-224.
  function casamRecipeHeroVariant(prod){
    var vs=(prod&&prod.variants)||[];
    var HERO=['10SSS','09CTJ','09CTL'];
    var sk=vs.filter(function(v){return v.available&&v.sku&&HERO.some(function(s){return String(v.sku).indexOf(s)>-1;});});
    if(sk.length)return sk[0];
    var av=vs.filter(function(v){return v.available;});
    return av[0]||vs[0]||null;
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-casam-qa-recipe]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var handle=b.getAttribute('data-handle');if(!handle||busy)return;
    busy=true;  // audit #19: guard the in-flight product fetch, not just the add, so a rapid double-click can't fire two /products/<handle>.js fetches
    var orig=b.textContent;b.textContent='Adding…';
    fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(prod){busy=false;var v=casamRecipeHeroVariant(prod);if(!v)throw 0;b.textContent=orig;
        var p=addWithSource(v.id,'recipe',b);if(p)p.then(function(){document.dispatchEvent(new CustomEvent('cart:open'));});})
      .catch(function(){busy=false;b.textContent=orig;window.location.href='/products/'+handle;});
  });

  // DRM-521 shoppable-homepage Quick add ([data-casam-qa-home]) → _added_from:'home'
  // (or the data-source the Liquid stamps). Mirrors the recipe quick-add precedent:
  // Liquid resolves the hero shaker variant server-side and stamps data-vid (fast
  // path, no extra fetch); data-handle is the fallback → client-side hero-variant
  // resolve via casamRecipeHeroVariant. Opens the drawer on add. addWithSource()
  // stamps the DRM-470 add-settle window, so the transient empty-cart LLM POST
  // guard covers these adds too.
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-casam-qa-home]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var src=b.getAttribute('data-source')||'home';
    var vid=b.getAttribute('data-vid');
    if(vid){
      var p=addWithSource(vid,src,b);
      if(p)p.then(function(){document.dispatchEvent(new CustomEvent('cart:open'));});
      return;
    }
    var handle=b.getAttribute('data-handle');if(!handle||busy)return;
    busy=true;  // same in-flight guard as the recipe quick-add (audit #19)
    var orig=b.textContent;b.textContent='Adding…';
    fetch('/products/'+handle+'.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(prod){busy=false;var v=casamRecipeHeroVariant(prod);if(!v)throw 0;b.textContent=orig;
        var p2=addWithSource(v.id,src,b);if(p2)p2.then(function(){document.dispatchEvent(new CustomEvent('cart:open'));});})
      .catch(function(){busy=false;b.textContent=orig;window.location.href='/products/'+handle;});
  });

  // Search dropdown quick-add  → _added_from:'search'  (also opens the cart drawer)
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.casam-search-add');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var p=addWithSource(b.getAttribute('data-vid'),'search',b);
    if(p)p.then(function(){document.dispatchEvent(new CustomEvent('cart:open'));});
  });

  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.casam-disc__btn');if(!b)return;
    e.preventDefault();
    var inp=document.querySelector('.casam-disc__input');var code=((inp&&inp.value)||'').trim();
    var msg=document.querySelector('.casam-disc__msg');
    if(!code){if(msg)msg.textContent='Enter a code';return;}
    if(msg)msg.textContent='Applying…';
    window.location.href='/discount/'+encodeURIComponent(code)+'?redirect=/cart';
  });
  // Events are a fast-path hint only (see the observer below for why they're not enough).
  // DRM-193 history: 'ajaxProduct:added' is the only event the theme fires on the FIRST add.
  // DRM-437: arm the LLM upsell on real engagement only. Registered before the
  // debounced refresh listeners run (same events), so the armed flag is already
  // set when the 250ms-debounced refresh executes.
  // 'drawerOpen.CartDrawer' is theme.js's own event, dispatched whenever the cart
  // drawer opens (theme.Drawers.open). Opening the drawer IS real cart engagement —
  // so it arms + refreshes even for a cold, EMPTY cart, which is the only way the
  // "Start your order" empty-cart recs ever get fetched (an empty drawer opened via
  // the header cart icon fires no cart:open/ajaxProduct:added). DRM-437-safe: scoped
  // to the cart drawer's namespaced event, so opening the search drawer won't fire it.
  ['cart:open','ajaxProduct:added','drawerOpen.CartDrawer'].forEach(function(ev){document.addEventListener(ev,function(){upsellArmed=true;});});
  /* DRM-470 add signals for the theme's own add path (casam quick-adds stamp inside
     addWithSource): the PDP product-form submit opens the settle window at click time
     (capture phase — theme.js preventDefaults the submit but propagation still reaches
     document), and ajaxProduct:added re-stamps when /cart/add.js lands, covering the
     buildCart → /cart.js settle gap. */
  document.addEventListener('submit',function(e){var f=e.target;if(f&&f.getAttribute&&/\/cart\/add/.test(f.getAttribute('action')||''))markAdd();},true);
  document.addEventListener('ajaxProduct:added',markAdd);
  ['cart:updated','cart:build','cart:open','ajaxProduct:added','drawerOpen.CartDrawer'].forEach(function(ev){document.addEventListener(ev,debounced);});

  /* PERMANENT free-ship-bar fix (root cause of the recurring "stale/empty bar on first add"):
     the bar must NOT depend on the theme firing a specific event. theme.js dispatches
     'cart:updated' only on a QUANTITY change — never after the initial add — and
     'ajaxProduct:added' can fire before /cart.js reflects the new line, so any event-only
     approach races and regresses (hence the repeated "add another event name" patches).
     Instead we watch the one invariant: theme.js buildCart() ALWAYS repopulates the
     [data-products] line-item container (after fetching authoritative cart markup) on the
     first add AND every change. Re-rendering off that DOM truth is event-name-agnostic, so
     it can't regress when the theme's event timing changes. The bar + upsell render into
     SIBLING nodes of [data-products], so our writes never retrigger this observer (no loop). */
  var cartProductsObserver=null;
  function observeCartProducts(){
    if(cartProductsObserver)return true;
    var host=document.querySelector('[data-products]');
    if(!host)return false;
    cartProductsObserver=new MutationObserver(debounced);
    cartProductsObserver.observe(host,{childList:true,subtree:true});
    return true;
  }
  function init(){
    // If the drawer markup isn't in the DOM yet, keep trying briefly (defensive; it's static liquid).
    if(!observeCartProducts()){var tries=0,iv=setInterval(function(){if(observeCartProducts()||++tries>20)clearInterval(iv);},150);}
    refresh();
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();

/* DRM-565: referral ?ref capture. Landing with ?ref=<code> (share_url from
   /apps/reviews/referral/code, DRM-563) persists the code to cart attribute
   `casam_ref` via /cart/update.js so order attribution survives to checkout.
   sessionStorage fallback covers the no-cart-yet case: /cart/update.js mints a
   cart, but if that cart is later replaced (checkout completed, cart expired),
   the add-event re-sync below re-applies the code to the NEW cart within the
   same session. First-touch wins: an existing non-empty casam_ref on the cart
   is never overwritten. Every fetch carries an AbortController timeout
   (estate doctrine). Separate IIFE — zero coupling to the drawer code above. */
(function(){
  var KEY='casam_ref';
  var ref=null;
  try{ref=new URLSearchParams(location.search).get('ref');}catch(e){}
  if(ref){ref=ref.trim().slice(0,64);}
  try{
    if(ref){sessionStorage.setItem(KEY,ref);}
    else{ref=sessionStorage.getItem(KEY);}
  }catch(e){/* storage blocked — a ?ref landing still applies below, just no fallback */}
  if(!ref)return;
  var inflight=false,t=null;
  function fetchT(url,opts,ms){
    opts=opts||{};
    var ctl=('AbortController' in window)?new AbortController():null;
    var tm=null;
    if(ctl){opts.signal=ctl.signal;tm=setTimeout(function(){ctl.abort();},ms||8000);}
    return fetch(url,opts).then(
      function(r){if(tm)clearTimeout(tm);return r;},
      function(e){if(tm)clearTimeout(tm);throw e;}
    );
  }
  function sync(){
    if(inflight)return;inflight=true;
    fetchT('/cart.js',{headers:{Accept:'application/json'}},8000)
      .then(function(r){return r.json();})
      .then(function(cart){
        var cur=cart&&cart.attributes&&cart.attributes[KEY];
        if(cur)return null;  /* first-touch wins — never overwrite */
        var attrs={};attrs[KEY]=ref;
        return fetchT('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:attrs})},8000);
      })
      .catch(function(){/* offline / timeout — the add-event re-sync retries */})
      .then(function(){inflight=false;});
  }
  function debounced(){clearTimeout(t);t=setTimeout(sync,600);}
  /* re-apply after cart creation/rebuild: first add can mint a fresh cart */
  ['ajaxProduct:added','cart:build','cart:updated'].forEach(function(ev){document.addEventListener(ev,debounced);});
  if(document.readyState!=='loading'){sync();}else{document.addEventListener('DOMContentLoaded',sync);}
})();

/* DRM-796: BYO 3-Pack bundle group controls (cart page + drawer).
   The pack lands as 4 cart lines: 3 zeroed child SKUs carrying properties._bundle
   = <token> and one parent line (BYO3PSSS) carrying properties._bundle_parent =
   <same token>. Liquid (snippets/cart-items.liquid + cart-item.liquid) renders
   the group as one thing — parent with price, children indented underneath with
   no controls — and this IIFE makes the parent's controls act on the WHOLE group:
     - qty change on the parent multiplies every line: parent qty n ⇒ each child
       line qty = n × its per-pack qty (per-pack derived live from /cart.js as
       child.quantity / parent.quantity, so it survives refreshes and repeats)
     - remove (or minus to 0 — the drawer's removal path) zeroes ALL group lines
       in ONE /cart/update.js call keyed by line keys (atomic: no half-removed pack)
   Tokens are only ever compared (===) against /cart.js data and read from data
   attributes — never interpolated into selectors or innerHTML (XSS hygiene).
   The parent markup deliberately avoids .js-qty__wrapper so theme.QtySelector
   can't fire a parent-only /cart/change.js. After the update we dispatch
   cart:build — theme.CartForm re-fetches the authoritative grouped markup.
   Separate IIFE — zero coupling to the drawer add-ons above. */
(function(){
  var busy=false;
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});}
  function groupFor(cart,token){
    var parent=null,children=[];
    (cart.items||[]).forEach(function(i){
      var p=(i&&i.properties)||{};
      if(p._bundle_parent===token){if(!parent)parent=i;}
      else if(p._bundle===token){children.push(i);}
    });
    return {parent:parent,children:children};
  }
  function setGroupQty(token,qty,lineEl){
    if(busy||!token)return;busy=true;
    qty=Math.max(0,parseInt(qty,10)||0);
    if(lineEl)lineEl.classList.add('is-loading');
    getCart().then(function(cart){
      var g=groupFor(cart,token);
      if(!g.parent)return null;   // parent already gone — just resync below (children fail open)
      var oldQty=g.parent.quantity>0?g.parent.quantity:1;
      var updates={};
      updates[g.parent.key]=qty;
      g.children.forEach(function(c){
        var perPack=Math.max(1,Math.round(c.quantity/oldQty));
        updates[c.key]=qty>0?perPack*qty:0;
      });
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates:updates})});
    })
    .catch(function(){})
    .then(function(){
      busy=false;
      if(lineEl)lineEl.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('cart:build'));   // theme.CartForm rebuilds both surfaces
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  }
  function lineFor(el){return el.closest('.cart__item--bundle-parent');}
  function tokenFor(el){var w=el.closest('[data-bundle-token]');return w?w.getAttribute('data-bundle-token'):null;}
  function inputFor(el){var w=el.closest('.casam-bqty');return w?w.querySelector('.casam-bqty__num'):null;}
  function readQty(inp){var n=parseInt(inp&&inp.value,10);return isNaN(n)?1:Math.max(0,n);}

  document.addEventListener('click',function(e){
    var plus=e.target.closest&&e.target.closest('.casam-bqty__plus');
    var minus=plus?null:(e.target.closest&&e.target.closest('.casam-bqty__minus'));
    if(!plus&&!minus)return;
    e.preventDefault();
    var btn=plus||minus,inp=inputFor(btn);if(!inp)return;
    var q=readQty(inp)+(plus?1:-1);if(q<0)q=0;   // minus to 0 removes the pack (drawer removal path)
    inp.value=q;
    setGroupQty(tokenFor(btn),q,lineFor(btn));
  });
  document.addEventListener('change',function(e){
    var inp=e.target.closest&&e.target.closest('.casam-bqty__num');if(!inp)return;
    var q=readQty(inp);inp.value=q;
    setGroupQty(tokenFor(inp),q,lineFor(inp));
  });
  /* Enter in the pack qty box must not implicitly submit the cart form (checkout) */
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter')return;
    var inp=e.target.closest&&e.target.closest('.casam-bqty__num');if(!inp)return;
    e.preventDefault();inp.blur();
  });
  /* Remove the whole pack. The anchor's href (parent-only /cart/change) stays as
     the no-JS fallback; the orphaned children then fail open as normal lines. */
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('.casam-bundle-remove');if(!a)return;
    e.preventDefault();
    setGroupQty(a.getAttribute('data-bundle-token'),0,lineFor(a));
  });
})();
